RivalIQ.apps.Dashboard.module('models', function (models, App, Backbone, Marionette, $, _) {

    'use strict';

    const timePeriods = RivalIQ.state.timePeriods;

    const Curation = Marionette.Dashboard.models.Curation;

    models.Curation = Curation.mixin({
        configurationModel: App.models.Configuration,

        mixins: {
            Export: App.mixins.Export,
            Title: App.mixins.Title
        },

        /*
         * widgets view - Collection view of widget panels
         */
        widgetsView: App.views.Widgets,

        /*
         * Single widget view - panel with actions outside panel
         */
        widgetView: function (child) {
            return child.getDetailWrapperView() || child.view;
        },

        /*
         * widgets export - renders widgets in vertical list with titlebar
         */
        exportWidgetsView: App.views.ExportWidgets,

        /*
         * PNG single widget export - wraps content in a panel
         */
        pngWidgetView: App.views.PngPanel,

        /*
         * PDF single widget export - prints a title directly on the background
         */
        pdfWidgetView: App.views.PdfPanel,

        /*
         * PPT single widget export - pass through w a spot for footer
         */
        pptWidgetView: App.views.PptPanel,

        /*
         * Default single widget export view has no chrome.
         */
        exportWidgetView: function (widget) {
            return widget.getView();
        },

        prependBeforeFilters: [

            /*
             * Expose global reference
             */
            function (curation) {
                RivalIQ.curation = curation;
            },

            /*
             * Guards against empty landscapes.
             */
            App.curations.filters.guardEmptyLandscape,

            /*
             * Set view state as curation props
             */
            App.curations.filters.initViewStateProps,

            /*
             * load curation configuration
             */
            Curation.filters.setConfiguration,

            /*
             * renders the emptyConfigurationView if no configuration is found
             */
            Curation.filters.missingConfigurationHandler,
            App.curations.filters.prepareWidgetInstanceState,

            /*
             * clears any popovers that may still be rendered
             */
            App.curations.filters.clearPopovers,

            /*
             * Run export setup
             */
            App.curations.filters.setupExport,

            /*
             * Initialize curation props with viewState and keep updated
             */
            App.curations.filters.watchViewState,

            /*
             * Update shell navigation and actions
             */
            App.curations.filters.updateShell,

            App.curations.filters.checkForAdBlockers
        ],

        appendBeforeFilters: [

            App.curations.filters.checkPostTagsCaches,

            /*
             * Load page data
             */
            App.curations.filters.startBuffering
        ],

        postRenderFilters: [
            App.curations.filters.endBuffering
        ],

        baseAfterFilters: [

            /*
             * Track curation view
             */
            App.curations.filters.track,
            App.curations.filters.showOnboardingModal,
            App.curations.filters.triggerScheduledReport,
            App.curations.filters.triggerExportTestHook,

            /*
             * Modify page for export and tell it to take a screenshot
             */
            App.curations.filters.completeExport
        ],

        /*
         * Override to support default filters
         */
        getFilters: function (key) {
            const me = this;

            switch (key) {
                case 'beforeFilters':
                    return me.prependBeforeFilters.concat(me.beforeFilters || []).concat(me.appendBeforeFilters);
                case 'afterFilters':
                    return me.baseAfterFilters.concat(me.afterFilters || []);
                default:
                    return me[key];
            }
        },

        /*
         * Keys that should be plucked from state and added to the curation
         * props
         *
         * When these values are changed the changes are pushed to setProps
         */
        stateProps: [
            'focusCompanyId',
            'landscapeId',
            'companySetDescriptor',
            'timePeriod',
            'timezone',
            'activeSources',
            'redactedSources',
            'supported_sources',
            'supported_main_time_periods',
            'plan',
            'email',
            'account_id'
        ],

        getStateProps: function () {
            const me = this;
            const exclusions = [];

            if (me.isTimePeriodDisabled()) {
                exclusions.push('timePeriod');
            }

            if (me.isCompanySetFilteringDisabled()) {
                exclusions.push('companySetDescriptor');
            }

            return _.without.apply(null, [me.stateProps].concat(exclusions));
        },

        getCurationId: function () {
            const me = this;
            return (String(me.id)).toLowerCase();
        },

        /*
         * By convention we typically specify widget definitions statically
         */
        buildConfiguration: function () {
            const me = this;
            const Model = me.configurationModel;

            return new Model({
                id: me.getProp('configurationId') || RivalIQ.enums.configurationType.PRIMARY,
                curation_id: me.getCurationId(),
                landscape_id: me.getProp('landscapeId'),
                definitions: _.result(me, 'widgetDefinitions')
            });
        },

        getName: function () {
            const me = this;
            return _.unescape(me.configuration.get('name'));
        },

        _getWidgetsView: function () {
            const me = this;


            const format = me.getProp('format');
            if (!format) {
                return Marionette.Dashboard.models.Curation.prototype._getWidgetsView.apply(me, arguments);
            }

            const view = me[`${format}WidgetsView`] || me.exportWidgetsView || me.widgetsView;
            return me._resolveView(view);
        },

        _getWidgetView: function (widget) {
            const me = this;

            const format = me.getProp('format');
            if (!format) {
                return Marionette.Dashboard.models.Curation.prototype._getWidgetView.apply(me, arguments);
            }

            const view = widget[`${format}View`] || me[`${format}WidgetView`] || me.exportWidgetView || me.widgetView;
            return me._resolveView(view, widget);
        },

        exportFormats: [
            RivalIQ.enums.exportFormat.PNG,
            RivalIQ.enums.exportFormat.PDF,
            RivalIQ.enums.exportFormat.PPT
        ],

        exportTypes: [
            RivalIQ.enums.exportType.EMAIL,
            RivalIQ.enums.exportType.DOWNLOAD,
            RivalIQ.enums.exportType.SCHEDULE
        ],

        getExportTitleBarTimePeriod: function () {
            const me = this;

            let timePeriodType = _.get(me.getNavigationComponents(), 'timePeriod.id');
            if (!timePeriodType) {
                timePeriodType = me.getProp('timePeriod').id;
            }

            if (timePeriodType === RivalIQ.enums.timePeriod.type.NOT_AVAILABLE) {
                timePeriodType = RivalIQ.enums.timePeriod.type.TODAY;
            }

            const timezone = RivalIQ.state.landscape.get('timezone');
            return RivalIQ.utils.timePeriod.getTimePeriodDisplayString(me.getProp('timePeriod'), timePeriodType, timezone);
        },

        getPath: function (overrides) {
            const me = this;
            // NOTE only pass query params by default
            return me.getBasePath(_.assign({}, _.clone(me.attributes), _.clone(me.queryProps), overrides));
        },

        isCompanySetFilteringDisabled: function () {
            const me = this;
            return me.companySets === false;
        },

        isTimePeriodDisabled: function () {
            const me = this;

            return _.includes([
                false,
                RivalIQ.enums.timePeriod.type.TODAY,
                RivalIQ.enums.timePeriod.type.NOT_AVAILABLE
            ], me.timePeriod);
        },

        getWidgetPropsForFormat: function () {
            const me = this;

            return me.getWidgets().reduce(function (memo, widget) {
                const props = widget.getPropsForCurationExport();
                if (_.size(props)) {
                    memo[widget.instanceId] = props;
                }

                return memo;
            }, {});
        },

        getPropsForFormat: function (format) {
            const me = this;

            const base = me.mixins.Export.getPropsForFormat.call(me, format);

            const widgetProps = me.getWidgetPropsForFormat(format);
            if (_.size(widgetProps)) {
                base.wProps = widgetProps;
            }
            return base;
        },

        getExportOrientation: function (format) {
            if (format === RivalIQ.enums.exportFormat.PPT) {
                return RivalIQ.enums.orientation.LANDSCAPE;
            }

            return RivalIQ.enums.orientation.PORTRAIT;
        },

        /*
         * Returns the navigation view or string for the shell title
         */
        getNavigationTitle: function () {
            const me = this;
            return _.result(me, 'titleView', me.getTitle());
        },

        /*
         * Returns component definitions for the shell controls
         */
        getNavigationComponents: function () {
            const me = this;
            const components = _.clone(me.components || {});

            components.timePeriod = me.getTimePeriodDefinition();

            if (me.companySets === false) {
                components.companySets = {
                    disabled: true
                };
            }

            components.dataFreshness = {
                disabled: (me.dataFreshness === false)
            };

            return components;
        },

        getTimePeriodDefinition: function () {
            const me = this;

            // This curation has a static timeperiod
            if (!_.isUndefined(me.timePeriod)) {
                return timePeriods.getDefinitionByType(me.timePeriod || RivalIQ.enums.timePeriod.type.NOT_AVAILABLE);
            }

            return {
                allowPrePostDataDates: me.allowPrePostDataDates
            };
        },

        getBackPath: function () {
            const me = this;
            return me.getBasePath();
        },

        backlinkName: 'Dashboard',

        getBackLinkName: function () {
            const me = this;
            return me.backlinkName;
        },

        backlinkClassName: 'btn btn-link',

        getBackLinkClassName: function () {
            const me = this;
            return me.backlinkClassName;
        },

        /*
         * Returns the ppt slide configuration for this curation
         */
        getSlides: function () {
            const me = this;

            const widgetSlides = _.flatten(me.getWidgets({
                reset: false
            }, {
                format: RivalIQ.enums.exportFormat.PPT
            }).map(function (widget) {
                return widget.getSlides({
                    curation: true
                });
            }));

            return [me.getTitleSlide()].concat(widgetSlides);
        },

        getTitleSlide: function () {
            const me = this;

            return RivalIQ.apps.Reports.models.Slide.createIntro(
                me,
                // TODO manage w/ params, not state
                RivalIQ.state.view.get('landscapeName'),
                RivalIQ.state.landscape.getCompanyById(me.getProp('focusCompanyId')).get('name')
            );
        },

        getSlideElements: function () {
            const me = this;

            // NOTE this is currently used by the React bridge(s) so that we
            // can power PPT exports...
            if (me.__slideElements) {
                return me.__slideElements;
            }

            if (me.isFocus()) {
                return {
                    header: {
                        title: me.getTitle(),
                        subtitle: me.getSubtitle()
                    }
                };
            }

            const focus = me.getWidgets().first();

            return focus?.getSlideElements();
        },

        widgetShouldIncludeTitleSlide: _.constant(false),

        shouldFilterWidgetFromExport: function (format, widget) {
            return widget.shouldShowChannelWall() ||
                (widget.supportedExportFormats && !_.includes(widget.supportedExportFormats, format));
        },

        /*
         * This curation level filter makes it easy for us to specify widgets
         * that should or shouldnt be included in curation level exports
         */
        rejectWidget: function (widget, overrides) {
            const me = this;

            if (!me.isFocus()) {
                return false;
            }

            overrides = overrides || {};
            const format = overrides.format || me.getProp('format');
            if (format) {
                return me.shouldFilterWidgetFromExport(format, widget);
            }

            return widget.exportOnly;
        },

        getExportStyles: function () {
            const branding = RivalIQ.state.view.getActiveBranding();
            return RivalIQ.utils.branding.overrideReportStyles(branding);
        },

        buildScheduledReport: function (attrs) {
            const me = this;

            if (me.isFocus()) {
                return me.mixins.Export.buildScheduledReport.call(me, attrs);
            }

            const widget = me.getWidgets().first();
            return widget.buildScheduledReport(attrs);
        },

        remove: function (child) {
            const me = this;

            const deferred = me.removeDefinition(child);
            me.trigger('unfavorited', child);
            child.trigger('unfavorited');
            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.RemoveFavoriteChartAnalyze, child.toJSON());
            return deferred;
        },

        favoriteExists: function (child, curation) {
            const me = this;
            curation = curation || me.favorites;

            return curation.favoriteExists(child);
        },

        reorderDefinitions: function (order) {
            const me = this;
            me.configuration.reorderDefinitions(order);
            me.getWidgets();
        },

        getViewTrackingOptions: function () {
            const me = this;
            const options = _.omit(me.getProps(), me.stateProps);

            // We often take the lack of a channel to mean cross channel
            // but doc doesn't like that (#10894). So, if we are switchable
            // fish out the channel and include it.
            if (me.getChannel && !options.channel) {
                options.channel = me.getChannel().get('channel');
            }

            return options;
        },

        getViewTracking: function () {
            const me = this;

            if (!me.isFocus()) {
                // Get the focus widget
                const focus = me.getWidgets().first();
                return focus && focus.getViewTracking();
            }

            const options = me.getViewTrackingOptions();

            return {
                name: `viewed_${me.getCurationViewTrackingId()}`,
                category: 'page_view',
                options: options
            };
        },

        getCurationViewTrackingId: function () {
            const me = this;
            return me.id;
        },

        getExportTracking: function (action, format) {
            const me = this;

            const options = _.extend(me.getProps(), {
                action: action,
                format: format
            });

            return {
                name: `exported_${me.id}`,
                category: 'export',
                options: options
            };
        },

        getScheduledExportTracking: function (format) {
            const me = this;

            const options = _.extend(me.getProps(), {
                format: format
            });

            return {
                name: `scheduled_export_${me.id}`,
                category: 'export',
                options: options
            };
        },

        processProps: _.identity,

        transformProps: function (props, changed) {
            const me = this;

            if (me.isExporting()) {
                return me.transformExportProps(props, changed);
            }

            if (props.focusCompanyId) {
                props.focusCompanyId = RivalIQ.state.utils.getFocusedCompanyId();
            }

            return me.processProps(props, changed);
        },

        setGlobalProps: function (props, options) {
            const me = this;
            me.setPropHash('globalProps', props, options);
        },

        teardown: function () {
            const me = this;

            RivalIQ.execute('tour:end');
            RivalIQ.execute('hide:modal');
            RivalIQ.execute('hide:tooltips');

            // unbind event and timer from social posts curation
            $(window).unbind('scroll');
            clearTimeout($.data(window, 'pageViewTimer'));

            Curation.prototype.teardown.call(me);

            // Let the server know this user is still active
            RivalIQ.state.user.updateActivity();

            // Invalidate any stale data caches we don't want to use on the next page
            RivalIQ.state.landscape.invalidateStaleCaches();
        },

        // TODO: this should be in marionette.dashboard
        getPropsForSerialization: function (props) {
            return props;
        },

        // TODO: this should be in marionette.dashboard (i think?)
        save: function (props, options) {
            const me = this;

            options = _.extend({
                success: function () {
                    me.resetPropHash('configurationProps', me.configuration.get('props'));
                }
            }, options);

            const attrs = me.toJSON();
            attrs.props = me.getPropsForSerialization(_.mergeEnumerable(_.defaults({}, props, me.attributes)));

            return Marionette.Dashboard.models.Model.prototype.save.call(me, attrs, options);
        },
        setWidgetInstanceState: function (widgetId, state) {
            const me = this;
            _.set(me, ['_widgetInstanceState', widgetId], state);
        },
        getWidgetInstanceState: function (widgetId) {
            const me = this;
            return _.get(me, ['_widgetInstanceState', widgetId]);
        },
        getCuration: function () {
            const me = this;
            return me;
        },

        // This is intended to be called only by the useRegisterSlideElementsForPPTExport hook.
        // NOTE this is exposed for the React bridge(s)
        _setSlideElements: function (slideElements) {
            const me = this;
            me.__slideElements = slideElements;
        }
    });

});
